export default __webpack_public_path__ + "static/media/banco.21bc66ea.svg";